import { toast } from "react-toastify";

export const handleFetchError = (error: unknown) => {
  console.log(error);
  toast.dismiss();
  if (typeof error === "string") {
    toast.error(error);
    return;
  }

  const errorMsg = (error as Error).message ?? "An error occurred";
  toast.error(errorMsg);
};
